<template>
  <v-dialog
    v-model="computedWintertrailsSkirunpolygonsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('wintertrails', 'skirunpolygons', false);
            date = null;
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedName }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="
              zoomTo({
                center: computedLatLng[0].geometry.coordinates[0][0][0],
                level: 16
              });
              // check if map layer is visible, toggle on if not so when we zoom to location
              // there is a dot to zoom to
              methodCloseListLayer('wintertrails', 'skirunpolygons');
              methodToggleSingleLayer('wintertrails', 'skirunpolygons', false);
            "
          >
            <v-icon>map</v-icon>
          </v-btn>
          <span>See on map</span>
        </v-tooltip>

        <!-- edit icon -->
        <!-- <v-tooltip bottom>
          <v-btn
            :color="disable_edit ? '' : 'primary'"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip> -->
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedWintertrailsSkirunpolygonsGeoJsonFeature"
          :loading="computedWintertrailsSkirunpolygonssLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Mountain</td>
              <td>
                {{ props.item.properties.mountain }}
              </td>
            </tr>
            <tr>
              <td>Zone</td>
              <td>{{ props.item.properties.ga_zone }}</td>
            </tr>
            <tr>
              <td>Run</td>
              <td>{{ props.item.properties.run }}</td>
            </tr>
            <tr>
              <td>Run Segment</td>
              <td>{{ props.item.properties.run_seg }}</td>
            </tr>
            <tr>
              <td>Level</td>
              <td>{{ props.item.properties.diff_lvl }}</td>
            </tr>
            <tr>
              <td>Surface Area(ac)</td>
              <td>{{ props.item.properties.sarea_acre }}</td>
            </tr>
            <tr>
              <td>Average Slop (%)</td>
              <td>
                {{
                  props.item.properties.avg_slope
                    ? Number(props.item.properties.avg_slope).toFixed(2)
                    : "Unknown"
                }}
              </td>
            </tr>
            <tr>
              <td>Top Elevation</td>
              <td>
                {{
                  props.item.properties.z_max
                    ? Number(props.item.properties.z_max).toFixed(2)
                    : "Unknown"
                }}
              </td>
            </tr>
            <tr>
              <td>Bottom Elevation</td>
              <td>
                {{
                  props.item.properties.z_min
                    ? Number(props.item.properties.z_min).toFixed(2)
                    : "Unknown"
                }}
              </td>
            </tr>
          </template>
          <!-- <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  @click.stop="
                    methodEditWintertrailsSkirunpolygonsGeoJson({
                      b_contents: $refs.ref_b_contents.value,
                      mlk_crate: $refs.ref_mlk_crate.value,
                      tb_content: $refs.ref_tb_content.value
                    });
                    disable_edit = true;
                    methodToggleSingleLayer(
                      'wintertrails',
                      'skirunpolygons',
                      false
                    );
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >

                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template> -->
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      // disable_edit: true,
      loading: true,
      hideheaders: true,
      hideactions: true
    };
  },
  computed: {
    computedLatLng() {
      if (this.computedWintertrailsSkirunpolygonsVisibility) {
        const skirunpolygons = this.$store.state.mapLayers.wintertrails.layers
          .skirunpolygons.geojson.features;
        const result = skirunpolygons.filter(
          item =>
            item.properties.id == this.computedWintertrailsSkirunpolygonsId
        );
        return result;
      }
      return [];
    },
    computedName() {
      let res;
      if (this.computedWintertrailsSkirunpolygonsVisibility) {
        const points = this.$store.state.mapLayers.wintertrails.layers
          .skirunpolygons.geojson.features;
        // grabs the location of the currently viewed ID
        let result = points.filter(
          item =>
            item.properties.id == this.computedWintertrailsSkirunpolygonsId
        );
        res = result[0].properties.location;
      }
      return res;
    },
    computedWintertrailsSkirunpolygonsGeoJsonFeature() {
      let res;
      if (
        this.$store.state.mapLayers.wintertrails.layers.skirunpolygons.geojson
          .features
      ) {
        const points = this.$store.state.mapLayers.wintertrails.layers
          .skirunpolygons.geojson.features;
        const result = points.filter(
          item =>
            item.properties.id == this.computedWintertrailsSkirunpolygonsId
        );
        res = result;
      }
      return res;
    },
    computedWintertrailsSkirunpolygonsVisibility() {
      return this.$store.state.mapLayers.wintertrails.layers.skirunpolygons
        .visibility.singleView;
    },
    computedWintertrailsSkirunpolygonssLoading() {
      return this.$store.state.mapLayers.wintertrails.layers.skirunpolygons
        .loading;
    },
    computedWintertrailsSkirunpolygonsId() {
      return this.$store.state.mapLayers.wintertrails.layers.skirunpolygons
        .visibility.singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodCloseListLayer(dept, layer) {
      this.$store.commit("mutationCloseListLayer", {
        dept: dept,
        layer: layer
      });
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetWintertrailsSkirunpolygonsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/wintertrails/skirunpolygons",
        dept: "wintertrails",
        layer: "skirunpolygons",
        token: this.computedAuthToken
      });
    },
    methodEditWintertrailsSkirunpolygonsGeoJson(data) {
      this.$store
        .dispatch("actionEditGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/wintertrails/skirunpolygons/" +
            this.computedWintertrailsSkirunpolygonsId,
          dept: "wintertrails",
          layer: "skirunpolygons",
          token: this.computedAuthToken,
          payload: data
        })
        .then(() => {
          setTimeout(() => {
            this.methodGetWintertrailsSkirunpolygonsGeoJson();
          }, 250);
        });
    },
    methodDeleteWintertrailsSkirunpolygonsGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/wintertrails/skirunpolygons/" +
            this.computedWintertrailsSkirunpolygonsId,
          dept: "wintertrails",
          layer: "skirunpolygons",
          token: this.computedAuthToken
        })
        .then(
          setTimeout(() => {
            this.methodGetWintertrailsSkirunpolygonsGeoJson();
          }, 250)
        );
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.wintertrails.layers.skirunpolygons.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetWintertrailsSkirunpolygonsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.wintertrails.layers.skirunpolygons.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
